import decisionTypeList from "./revision-number/decision-type";

export default [...decisionTypeList];